//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('请输入邮箱'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    var checkPassword = (rule, value, callback) => {
      const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/ // 校验密码6-18位
      if (!value) {
        return callback(new Error('请设置密码'))
      }
      setTimeout(() => {
        if (passwordReg.test(value)) {
          callback()
        } else {
          callback(
            new Error('密码须包含数字、字母两种元素，且密码位数为6-16位')
          )
        }
      }, 100)
    }
    var checkcPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请设置密码'))
      }
      if (this.dataForm.password !== value) {
        callback(new Error('两次密码输入不一致！'))
      } else {
        callback()
      }
    }
    return {
      registing: false,
      dataForm: {
        username: '',
        password: '',
        cpassword: '',
        verifycode: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: checkPassword, trigger: 'blur' }
        ],
        cpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: checkcPassword, trigger: 'blur' }
        ],
        verifycode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      checked: false,
      pwdType: 'password',
      eyeType: 'el-input__icon el-icon-view',
      imgSrc: this.$api.validateCode
    }
  },
  methods: {
    tologin() {
      this.$router.push({ path: '/login' })
    },
    handleSubmit(event) {
      this.$refs.dataForm.validate(valid => {
        let that = this
        if (valid) {
          this.registing = true
          let params = {
            UserName: this.dataForm.username.trim(),
            Password: this.dataForm.password.trim(),
            VerifyCode: this.dataForm.verifycode.trim()
          }
          this.$api
            .register(params)
            .then(res => {
              this.registing = false
              if (res.Status === 1) {
                this.$alert('注册成功，请登录！', '提示', {
                  confirmButtonText: '前往登录',
                  callback: action => {
                    this.$router.push({ path: '/' })
                  }
                })
              } else {
                this.$alert(res.Message, '错误', {
                  confirmButtonText: '确定'
                })

                that.refreshCode()
              }
            })
            .catch(function(res) {
              that.$alert('无法注册', '网络错误', {
                confirmButtonText: '确定'
              })

              that.refreshCode()
            })
        } else {
          that.$alert('无法注册', '错误', {
            confirmButtonText: '确定'
          })
          that.refreshCode()
          return false
        }
      })
    },
    showPassword(event) {
      if (this.pwdType === 'password') {
        this.pwdType = 'text'
        this.eyeType = 'el-input__icon el-icon-loading'
      } else {
        this.pwdType = 'password'
        this.eyeType = 'el-input__icon el-icon-view'
      }
    },
    refreshCode() {
      let src = this.imgSrc
      this.imgSrc = ''
      this.$nextTick(() => {
        this.imgSrc = src + '?'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Regist.vue